var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceGlyphPercent = function SvgInterfaceGlyphPercent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 96 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.899 516Q236 516 198 477.899t-38-92T198.101 294t92-38T382 294.101t38 92T381.899 478t-92 38m-.017-60Q319 456 339.5 435.618t20.5-49.5-20.382-49.618-49.5-20.5-49.618 20.382-20.5 49.5 20.382 49.618 49.5 20.5m380.017 440Q616 896 578 857.899t-38-92T578.101 674t92-38T762 674.101t38 92T761.899 858t-92 38m-.017-60Q699 836 719.5 815.618t20.5-49.5-20.382-49.618q-20.383-20.5-49.5-20.5T620.5 716.382q-20.5 20.383-20.5 49.5t20.382 49.618q20.383 20.5 49.5 20.5M202 896l-42-42 598-598 42 42z"
  })));
};
export default SvgInterfaceGlyphPercent;